import React, { useEffect } from "react";
import { LedgerStatementType, MonthlyLedgerSummaryDataType } from "../../../../redux/reports/reportsType";
import {
  currencySignAndNegativeValueAdjust,
  formatDate,
} from "../../../../utils/commonFunctions";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Iicon, tableEditIcon } from "../../../../assets/images";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../../../constant/colors";
import "../../Reports.scss"

type AppProps = {
  monthlyLedgerSummaryData: [] | MonthlyLedgerSummaryDataType[];
  client_code: number;
  company_name: string;
  currencySign: string;
};

const MonthlyLedgerSummaryTableData = ({
  monthlyLedgerSummaryData,
  client_code,
  company_name,
  currencySign,
}: AppProps) => {

  const backColor = (type: number) => {
    let backgroundColor;
    let fontColor;

    if (type === 1) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (type === 2) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (type === 3) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };

  const styleColor = (type: number) => {
    const { backgroundColor, fontColor } = backColor(type);

    return {
      marginTop: "20px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const renderLedgerStatementData = () => {
    let finalData =
      monthlyLedgerSummaryData &&
      monthlyLedgerSummaryData?.length > 0 &&
      monthlyLedgerSummaryData?.map((ledgerData: MonthlyLedgerSummaryDataType) => {
        
        return (
          <tr className="text-center" key={ledgerData?.month}>
            <td style={{ width: "450px" }}>
              {ledgerData?.month}
            </td>
            

            <td className="text-success width">
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.total_debits
                  ? ledgerData?.total_debits?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
            <td className="text-danger width">
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.total_credits
                  ? ledgerData?.total_credits?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
            <td className="width">
              {currencySignAndNegativeValueAdjust(
                currencySign,
                ledgerData?.closing_balance
                  ? ledgerData?.closing_balance?.toFixed(2)?.toString()
                  : "0"
              )}
            </td>
          </tr>
        );
      });

    return finalData;
  };

  return <>{renderLedgerStatementData()}</>;
};

export default MonthlyLedgerSummaryTableData;
